export default {
    page_title: "Kevi | Agregar Cliente",
    title: "Agregar Cliente",
    labels: {
        external_id: "ID Integracion",
        first_name: "Primer nombre",
        last_name: "Apellido",
        whatsapp: "Celular",
        email: "E-mail",
        birthdate: "Fecha de nacimiento",
        subscribe: "Enviar:",
    },
    placeholders: {
        whatsapp: "(##) #####-####",
        birthdate: "dd/mm/aaaa",
    },
    channels: {
        sms: "SMS",
        email: "E-mail",
        whatsapp: "WhatsApp",
    },
    errors: {
        invalid_phone: "Telefono invalido",
        duplicate_phone: "Ya existe un cliente con este telefono",
        invalid_email: "Email invalido",
        duplicate_email: "Ya existe un cliente con este email",
        invalid_birthdate: "Fecha invalida",
    },
    cancel: "Cancelar",
    save: "Guardar",
};
